module.exports = __webpack_public_path__ + "static/img/n9m3.644d320.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/n9m/n9m3.jpg
// module id = L0wb
// module chunks = 1